var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pb-3" },
    [
      _c(
        _vm.isLink ? "a" : "div",
        {
          tag: "component",
          attrs: { href: _vm.isLink ? _vm.link : null, target: "_blank" },
          on: {
            click: function ($event) {
              _vm.isLink ? _vm.registerClick() : null
            },
          },
        },
        [
          _c("h4", { staticClass: "primary--text d-inline" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _vm.isLink
            ? _c("div", { staticClass: "d-inline content-section-tags" })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }